import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { environment } from '@environment';
import { Subject, takeUntil } from 'rxjs';

import { NgStyle } from '@angular/common';
import { OutletStatusStripService } from '@app/core/services/outlet-status-strip/outlet-status-strip.service';
import { OutletService } from '@app/core/services/outlet/outlet.service';
import { OutletState, OutletStatus } from '@app/shared/models/api-response/catalog-api-response';

@Component({
    selector: 'outlet-status-strip',
    templateUrl: './outlet-status-strip.component.html',
    styleUrls: ['./outlet-status-strip.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class OutletStatusStripComponent implements OnInit, OnDestroy {
    @Input() style = {};
    @Output() onRefreshClick = new EventEmitter();
    DEPLOY_URL: string;
    environment = environment;

    icon = '';
    message = '';
    header = '';
    showStrip = false;
    allowRefresh: boolean;
    outletState: OutletState;
    OutletState = OutletState;
    destroySubscription$: Subject<void> = new Subject();

    constructor(
        private outletStatusStripService: OutletStatusStripService,
        private outletService: OutletService
    ) {
        this.DEPLOY_URL = environment.DEPLOY_URL;
    }

    ngOnInit() {
        this.outletStatusStripService.outletStatusStrip.pipe(takeUntil(this.destroySubscription$)).subscribe(status => {
            this.updateStatusStrip(status);
        });
    }

    updateStatusStrip(status: OutletStatus | null) {
        if (!status) {
            this.showStrip = false;
            return;
        }

        const { heading, message, allow_refresh, icon, outlet_state } = status;

        this.header = heading;
        this.message = message;
        this.outletState = outlet_state;
        this.allowRefresh = allow_refresh;
        this.icon = `${environment.assetsUrl}/outlet_status/${icon}`;

        const isOutletSelected = this.outletService.isOutletSelected();
        this.showStrip = Boolean(heading && message && isOutletSelected);
    }

    ngOnDestroy() {
        this.destroySubscription$.next();
        this.destroySubscription$.complete();
    }
}
